import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'dva/router';
import App from './routes/app';

const registerModel = (app, model) => {
  if (!(app._models.filter(m => m.namespace === model.namespace).length === 1)) {
    app.model(model);
  }
};

const Routers = ({ history, app }) => {
  const routes = [
    {
      path: '/',
      component: App,
      getIndexRoute (nextState, cb) {
        require.ensure([], (require) => {
          registerModel(app, require('./models/dashboard').default);
          cb(null, { component: require('./routes/dashboard/').default });
        }, 'dashboard');
      },
      childRoutes: [
        {
          path: '/dashboard',
          getComponent (nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/dashboard').default);
              cb(null, require('./routes/dashboard/').default);
            }, 'dashboard');
          },
        },
        {
          path: '/company',
          getComponent (nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/company').default);
              cb(null, require('./routes/company/').default);
            }, 'company');
          },
        },
        {
          path: '/user',
          getComponent (nextState, cb) {
            require.ensure([], (require) => {
              registerModel(app, require('./models/user').default);
              cb(null, require('./routes/user/').default);
            }, 'user');
          },
        },
        {
          path: '*',
          getComponent (nextState, cb) {
            require.ensure([], (require) => {
              cb(null, require('./routes/error/').default);
            }, 'error');
          },
        },
      ],
    },
  ];

  return <Router history={history} routes={routes} />;
};

Routers.propTypes = {
  history: PropTypes.object,
  app: PropTypes.object,
};

export default Routers;



// WEBPACK FOOTER //
// ./src/router.js